import * as PropTypes from "prop-types";
import styled from "styled-components";
import Repeat from "images/SwitchIcon";
import Header from "basicComponents/Header/Header";
import IconActionButton from "basicComponents/IconActionButton/IconActionButton";

export default function PracticeChange({
  title,
  children,
  onClick,
  practices,
}) {
  if (practices.length > 1) {
    return (
      <Wrapper data-cy="selectPracticeButton">
        <IconActionButtonWrapper>
          <IconActionButton onClick={onClick} icon={<Repeat />}>
            {children}
          </IconActionButton>
        </IconActionButtonWrapper>
      </Wrapper>
    );
  }

  return null;
}

PracticeChange.propTypes = {
  title: PropTypes.any,
  children: PropTypes.any,
  onClick: PropTypes.func,
  practices: PropTypes.array,
};

const IconActionButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const Wrapper = styled.div`
  //Temporary button location!!@#!@#
  //transform: translate(-4.5vw, -1vw);
  //margin-left: -8rem;
`;
